import { Component, ChangeDetectionStrategy, Input, HostBinding } from "@angular/core";

@Component({
    selector: "sps-key-value-list-item",
    templateUrl: "./sps-key-value-list-item.component.html",
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SpsKeyValueListItemComponent {
    static readonly displayName = "sps-key-value-list-item";
    static readonly props = {
        key: { type: "string", required: true },
    };

    @Input() key: string;

    @HostBinding("class.sps-key-value-list__item") readonly _spsKeyValueListItemClass = true;
}
